import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const RelationshipStatusSection = ({ formData, errors, onChange }) => {
  const relationshipOptions = [
    { value: 'single', label: 'Single', description: 'Not in a relationship' },
    { value: 'married', label: 'Married', description: 'Currently married' },
    { value: 'divorced', label: 'Divorced', description: 'Previously married' },
    { value: 'separated', label: 'Separated', description: 'Living separately' },
    { value: 'complicated', label: 'It\'s Complicated', description: 'Complex relationship status' },
    { value: 'prefer-not-say', label: 'Prefer Not to Say', description: 'Keep status private' }
  ];

  const lookingForOptions = [
    { value: 'friendship', label: 'Friendship', description: 'Platonic connections' },
    { value: 'casual', label: 'Casual Dating', description: 'No strings attached' },
    { value: 'serious', label: 'Serious Relationship', description: 'Long-term commitment' },
    { value: 'discreet', label: 'Discreet Affair', description: 'Private connection' },
    { value: 'emotional', label: 'Emotional Connection', description: 'Deep conversations' },
    { value: 'exploring', label: 'Just Exploring', description: 'Open to possibilities' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <h3 className="text-lg md:text-xl font-heading font-semibold mb-4 md:mb-6">
        Relationship Status
      </h3>
      <div className="space-y-4 md:space-y-5">
        <Select
          label="Current Status"
          name="relationshipStatus"
          placeholder="Select your relationship status"
          description="Be honest about your current situation"
          options={relationshipOptions}
          value={formData?.relationshipStatus}
          onChange={(value) => onChange({ target: { name: 'relationshipStatus', value } })}
          error={errors?.relationshipStatus}
          required
        />

        <Select
          label="Looking For"
          name="lookingFor"
          placeholder="What are you seeking?"
          description="Help others understand your intentions"
          options={lookingForOptions}
          value={formData?.lookingFor}
          onChange={(value) => onChange({ target: { name: 'lookingFor', value } })}
          error={errors?.lookingFor}
          required
        />

        <div className="p-4 bg-primary/5 rounded-lg">
          <div className="flex items-start gap-3">
            <Icon name="Heart" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-caption font-semibold mb-1">Honest Connections</h4>
              <p className="text-xs text-muted-foreground">
                Being transparent about your status and intentions helps create meaningful connections with like-minded individuals.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelationshipStatusSection;